import { useState } from 'react';

import { Button, showToast, Switch, Typography } from '@attentive-platform/stem-ui';

import { FormContainer } from '../../styled';
import { EmailInput } from '../../uicomponents';
import { useBlockUser, useUnblockUser } from '../../Utils/services';
import { isBeamUser, isValidEmail } from '../../Utils/HelperFunctions';

export const BlockUser = () => {
  const [email, setEmail] = useState('');
  const [isBlocked, setIsBlocked] = useState(true);

  const { mutate: blockUser, loading } = useBlockUser();
  const { mutate: unblockUser, loading: unblockUserLoading } = useUnblockUser();

  const beamUser = isBeamUser();

  const onSubmitHandler = () => {
    const data = { email };
    const mutateFn = isBlocked ? blockUser : unblockUser;

    mutateFn(
      { data },
      {
        onSuccess: () => {
          showToast(`User ${isBlocked ? 'blocked' : 'unblocked'} successfully`, 'success');
          setEmail('');
        },
        onError: error => {
          showToast(error, 'error');
        }
      }
    );
  };

  return (
    <FormContainer>
      <EmailInput
        name='bu-page-email'
        value={email}
        onChange={(_, value) => {
          setEmail(value);
        }}
      />

      {!beamUser && (
        <div className='flex items-center gap-4'>
          <Typography variant='body1'>Block user:</Typography>
          <Switch size='small' checked={isBlocked} onChange={() => setIsBlocked(!isBlocked)} />
        </div>
      )}

      <div>
        <Button
          onClick={onSubmitHandler}
          loading={loading || unblockUserLoading}
          disabled={!email || !isValidEmail(email)}>
          {isBlocked ? 'Block ' : 'Unblock '} user
        </Button>
      </div>
    </FormContainer>
  );
};
